import { StyledButton, lightColors } from '@tryhackme/thm-ui-components';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider, useTheme } from 'styled-components';
import { useGetUserQuery } from 'src/common/slices';
import { useCampaignCta } from 'src/features/campaigns/hooks/use-campaign-cta';
import { StyledBar } from './fireship-top-bar.styles';
import type { FireshipBarProps } from './fireship-top-bar.types';
export const FireshipTopBar: FC<FireshipBarProps> = ({
  embedded
}) => {
  const theme = useTheme();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const [ctaText, urlToNavigate] = useCampaignCta();
  const url = userDataResponse?.data ? urlToNavigate : '/signup?source=fireship';
  return <ThemeProvider theme={{
    ...theme,
    colors: lightColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="FireshipTopBar" data-sentry-source-file="fireship-top-bar.tsx">
      <StyledBar embedded={embedded} data-sentry-element="StyledBar" data-sentry-source-file="fireship-top-bar.tsx">
        <p data-testid="campaign-promotion-text">
          <span>Limited time offer:</span> Fireship Viewers Exclusive <span>20% off</span> annual subscriptions!
        </p>
        <StyledButton as={Link} to={url} variant="solid" color="primary" size="small" data-sentry-element="StyledButton" data-sentry-source-file="fireship-top-bar.tsx">
          {ctaText}
        </StyledButton>
      </StyledBar>
    </ThemeProvider>;
};